import { inject } from './inject';
import { PciProxyPaymentCardFormSection as BasePciProxyPaymentCardFormSection } from './PciProxyPaymentCardFormSection';

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export const PciProxyPaymentCardFormSection = inject(BasePciProxyPaymentCardFormSection);
